import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getHotelSelector } from "../../../store/hotel/hotel-selector";
import { useHistory, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { getDifferenceInNights } from "../../../helpers/date";
import { updateQueryStringParameter } from "../../../helpers/url";
import { isBronui } from "../../../config";


const useAccommodationPackage = ({onOpen}) => {
  const hotel = useSelector(getHotelSelector);
  const {id} = hotel.data;
  const location = useLocation();
  const history = useHistory();

  const params = new URLSearchParams(location.search)
  const arrival_date = params.get('arrival_date')
  const departure_date = params.get('departure_date')


  const hotelsWithAccommodationPackage = [
  //   {
  //   id: 6696,
  //   periodFrom: '2024-12-27',
  //   periodTo: '2025-01-05',
  //   accommodationPackageDays: [],
  //   message: 'В даному готелі на період з 27 грудня по 5 січня діє пакетне бронювання. Можливість забронювати номер на дві або більше ночей.'
  // },{
  //   id: 7,
  //   periodFrom: '2024-12-27',
  //   periodTo: '2025-01-05',
  //   accommodationPackageDays: [],
  //   message: 'В даному готелі на період з 27 грудня по 5 січня діє пакетне бронювання. Можливість забронювати номер на дві або більше ночей.'
  // },{
  //   id: 4922,
  //   periodFrom: '2024-12-27',
  //   periodTo: '2025-01-05',
  //   accommodationPackageDays: [],
  //   message: 'В даному готелі на період з 27 грудня по 5 січня діє пакетне бронювання. Можливість забронювати номер на дві або більше ночей.'
  // },
    {
    id: 6716,
    periodFrom: null,
    periodTo: null,
    accommodationPackageDays: ['2025-06-27', '2025-06-28', '2025-07-11', '2025-07-12','2025-07-25', '2025-07-26','2025-08-22', '2025-08-23', '2025-08-24'],
    message: "В даному готелі на дати 27.06.2025, 28.06.2025, 11.07.2025, 12.07.2025, 25.07.2025, 26.07.2025, 22.08.2025, 23.082025, 24.08.2025  діє пакетне бронювання. Можливість забронювати номер на дві або більше ночей."
  },
    // тавель
    {
      id: 898,
      periodFrom: '2025-07-01',
      periodTo: '2025-08-31',
      accommodationPackageDays: [],
      message: 'В даному готелі на період з 1 липня по 31 серпня діє пакетне бронювання. Можливість забронювати номер на дві або більше ночей.'
    },
    // хвоя
    {
      id: 943,
      periodFrom: '2025-07-01',
      periodTo: '2025-08-31',
      accommodationPackageDays: [],
      message: 'В даному готелі на період з 1 липня по 31 серпня діє пакетне бронювання. Можливість забронювати номер на дві або більше ночей.'
    },

    //Huston
    {
      id: 3260,
      periodFrom: '2025-12-20',
      periodTo: '2026-01-07',
      accommodationPackageDays: [],
      message: 'В даному готелі на період з 20 грудня по 7 січня діє пакетне бронювання. Можливість забронювати номер на дві або більше ночей.'
    }

  ]

  const [currentAccommodationPackage, setCurrentAccommodationPackage] = useState(null);
  useEffect(()=>{
    const findCurrent = hotelsWithAccommodationPackage.find(item => item.id === id);


    if(findCurrent && isBronui){
      const arrival_date_period = arrival_date ? arrival_date :  dayjs(new Date()).format('YYYY-MM-DD')

      if(findCurrent.periodFrom && findCurrent.periodTo){
        const isPeriod = dayjs(arrival_date_period).isAfter(dayjs(findCurrent.periodFrom)) &&  dayjs(arrival_date_period).isBefore(dayjs(findCurrent.periodTo));

        if(isPeriod){
          // якщо є дати і бронювання тільки на 1 день
          if(arrival_date && departure_date && getDifferenceInNights(arrival_date, departure_date) <= 1 ){
            const a = dayjs(departure_date)
            const b = a.add(1, 'day')

            const queryParams = updateQueryStringParameter(location.search, 'departure_date', b.format('YYYY-MM-DD'));
            history.push(`${location.pathname}${queryParams}`)
            setCurrentAccommodationPackage(findCurrent)
            onOpen()
          }


          if(!params.get('departure_date')){
            const a = dayjs(new Date())
            const b = a.add(2, 'day')
            history.push(`${location.pathname}?arrival_date=${a.format('YYYY-MM-DD')}&departure_date=${b.format('YYYY-MM-DD')}`)
            setCurrentAccommodationPackage(findCurrent)
            onOpen()
          }
        } else {
          setCurrentAccommodationPackage(null)
        }
      } else {
        if(findCurrent.accommodationPackageDays.length){
          if(arrival_date && departure_date){
            const findSelectedDay = findCurrent.accommodationPackageDays.find(item => item === arrival_date);
            const a = dayjs(departure_date)
            const b = a.add(1, 'day')

            if(findSelectedDay && getDifferenceInNights(arrival_date, departure_date) <= 1 ){

              const queryParams = updateQueryStringParameter(location.search, 'departure_date', b.format('YYYY-MM-DD'));
              history.push(`${location.pathname}${queryParams}`)

              setCurrentAccommodationPackage(findCurrent)
              onOpen()
            }
          } else {
            const findSelectedDay = findCurrent.accommodationPackageDays.find(item => item === dayjs(new Date()).format('YYYY-MM-DD'));

            if(findSelectedDay){
              const a = dayjs(new Date())
              const b = a.add(2, 'day')
              history.push(`${location.pathname}?arrival_date=${a.format('YYYY-MM-DD')}&departure_date=${b.format('YYYY-MM-DD')}`)
              setCurrentAccommodationPackage(findCurrent)
              onOpen()
            }
          }

        }
      }
    }

  },[id, arrival_date, departure_date])

  return {
    currentAccommodationPackage
  }
}

export default useAccommodationPackage;